import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {SelectButton} from "primeng/selectbutton";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {TranslocoPipe} from "@jsverse/transloco";

@Component({
  selector: 'homey-household-size-input',
  imports: [
    SelectButton,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './household-size-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HouseholdSizeInputComponent {
  control = input.required<FormControl<number | undefined>>();

  protected householdSizeOptions: { value: number, label: string }[] = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
    {value: 5, label: "5"},
    {value: 6, label: "6"},
    {value: 7, label: "7"},
  ];
}
